<template>
  <div>
    <el-card :body-style="{ height: '100%' }" class="h-full" v-if="showList">
      <div class="flex flex-wrap">
        <el-input
          clearable
          v-model="search.name"
          class="w-200px mr-10px mb-10px"
          size="small"
          :maxlength="50"
          :placeholder="`${$t('评价名称')}`"
        ></el-input>
        <el-input
          clearable
          v-model="search.organization"
          class="w-200px mr-10px mb-10px"
          size="small"
          :maxlength="50"
          :placeholder="`${$t('评价单位')}`"
          v-if="source === 2"
        ></el-input>
        <select-tree
          v-model="search.organizationId"
          :optionList="departmentList"
          :treeProps="{
            label: 'displayName',
            children: 'children',
          }"
          :placeholder="`${$t('评价单位')}`"
          class="w-200px mr-10px"
          v-else
        />

        <el-input
          clearable
          v-model="search.section"
          class="w-200px mr-10px mb-10px"
          size="small"
          :maxlength="50"
          :placeholder="`${$t('所属标段')}`"
          v-if="source === 0"
        ></el-input>
        <el-button @click="searchList" size="small" type="primary">{{ $t('搜索') }}</el-button>
        <el-button @click="reset" size="small">{{ $t('重置') }}</el-button>
        <el-button
          @click="operate('create', null)"
          size="small"
          type="primary"
          :disabled="!$hasAccess('create')"
          >{{ $t(source === 2 ? '新增评审' : '新增自评') }}</el-button
        >
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        stripe
        height="calc(100% - 104px)"
        class="mt-10px"
        ref="table"
      >
        <el-table-column width="60" :label="`${$t('序号')}`" type="index"></el-table-column>
        <el-table-column
          prop="name"
          show-overflow-tooltip
          :label="`${$t('评价名称')}`"
        ></el-table-column>
        <el-table-column
          prop="creator"
          show-overflow-tooltip
          :label="`${$t('评价人')}`"
        ></el-table-column>
        <el-table-column
          prop="organization"
          show-overflow-tooltip
          :label="`${$t('评价单位')}`"
        ></el-table-column>
        <el-table-column
          prop="section"
          show-overflow-tooltip
          :label="`${$t('所属标段')}`"
          width="120px"
          v-if="source === 0"
        ></el-table-column>
        <el-table-column
          prop="beginTime"
          show-overflow-tooltip
          :label="`${$t('评价开始时间')}`"
        ></el-table-column>
        <el-table-column
          prop="totalStandardScore"
          show-overflow-tooltip
          :label="`${$t('评价标准总分')}`"
        ></el-table-column>
        <el-table-column
          prop="totalScore"
          show-overflow-tooltip
          :label="`${$t('自评得分')}`"
        ></el-table-column>
        <el-table-column
          prop="scorePercentage"
          show-overflow-tooltip
          :label="`${$t('得分占比')}`"
        ></el-table-column>
        <el-table-column
          prop="statusName"
          show-overflow-tooltip
          :label="`${$t('自评状态')}`"
        ></el-table-column>
        <el-table-column show-overflow-tooltip label="操作" width="270px">
          <template slot-scope="scope">
            <table-operate-button :key="scope.row.id" :buttons="buttons(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px text-right"
        background
        :current-page.sync="page.pageNo"
        @size-change="searchList"
        @current-change="findList"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :page-size.sync="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
    <evaluation-form
      v-else
      :mode="viewMode"
      :id="rowId"
      :source="source"
      @cancel="showList = true"
      @refresh="refresh"
    ></evaluation-form>
  </div>
</template>

<script>
import { SafetyEvaluationSolutionApi } from '@wiz-api/safety-evaluation-management'
import { OrganizationApi } from '@wiz-api/abp-identity'
import dayjs from 'dayjs'
import { download } from '@/assets/js/CommonDownload'

const SelectTree = () => {
  return import('@/components/safety/FormSelect/SelectTree')
}
const EvaluationForm = () => {
  return import('./EvaluationForm')
}
const TableOperateButton = () => {
  return import('@/components/safety/TableOperateButton/TableOperateButton')
}
const organizationApi = new OrganizationApi()
const safetyEvaluationSolutionApi = new SafetyEvaluationSolutionApi()
export default {
  components: {
    SelectTree,
    EvaluationForm,
    TableOperateButton,
  },
  data() {
    return {
      departmentList: [],
      search: {
        name: '',
        organizationId: '',
        section: '',
        organization: '',
      },
      page: {
        pageNo: 1,
        pageSize: 15,
      },
      total: 0,
      loading: false,
      tableData: [],
      showList: true,
      viewMode: '',
      rowId: '',
    }
  },
  computed: {
    buttons() {
      return (val) => {
        return [
          {
            text: '查看',
            click: () => {
              return this.operate('read', val)
            },
            isShow: this.$hasAccess('read'),
          },
          {
            text: '编辑',
            click: () => {
              return this.operate('update', val)
            },
            isShow: this.$hasAccess('update') && val.status === 0,
          },
          {
            text: '删除',
            click: () => {
              return this.deleteData(val)
            },
            isShow: this.$hasAccess('delete') && [0].includes(val.status),
          },
          {
            text: '评价',
            click: () => {
              return this.operate('evaluate', val)
            },
            isShow: this.$hasAccess('evaluate') && val.status === 1,
          },
          {
            text: '导出',
            click: () => {
              return this.operate('export', val)
            },
            isShow: this.$hasAccess('export') && val.status === 2,
          },
        ]
      }
    },
    source() {
      const statusMap = {
        stakeholderEvaluationList: 0,
        unitEvaluationList: 1,
        expertEvaluationList: 2,
      }
      return statusMap[this.$route.name]
    },
  },
  watch: {
    '$route.name': {
      handler(val) {
        if (val) {
          this.search = this.$options.data().search
          this.page = this.$options.data().page
          this.refresh()
        }
      },
    },
  },
  methods: {
    async findList() {
      this.tableData = []
      this.loading = true
      const [err, res] = await safetyEvaluationSolutionApi.getByPage(this.source, {
        ...this.search,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
      })
      if (!err) {
        const statusMap = {
          0: '待发布',
          1: '自评中',
          2: '已自评',
        }
        this.tableData = res.items.map((item) => {
          return {
            ...item,
            statusName: statusMap[item.status],
            beginTime: dayjs(item.beginTime).format('YYYY-MM-DD'),
            scorePercentage: `${item.scorePercentage * 100}%`,
          }
        })
        this.total = res.totalCount
      }
      this.loading = false
    },
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    reset() {
      this.search = this.$options.data().search
      this.searchList()
    },
    async operate(type, row) {
      if (type !== 'export') {
        this.viewMode = type
        this.rowId = row?.id || ''
        this.showList = false
      } else {
        const [err, res] = await safetyEvaluationSolutionApi.callExport(row.id)
        if (!err) {
          download(
            `${row.name}`,
            res,
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          )
        }
      }
    },
    deleteData(row) {
      this.$confirm('是否确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err] = await safetyEvaluationSolutionApi.callDelete(row.id)
          if (!err) {
            this.$message.success('删除成功！')
            this.searchList()
          }
        })
        .catch(() => {})
    },
    async getOrgData() {
      const [err, res] = await organizationApi.getAllListDetails({})
      if (!err && res?.items.length) {
        this.departmentList = res?.items
        // this.departmentList = res?.items[0].children
      }
    },
    refresh() {
      this.showList = true
      this.searchList()
    },
  },
  created() {
    this.getOrgData()
    this.searchList()
  },
}
</script>

<style></style>
